import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4 d-flex align-items-center" }
const _hoisted_2 = { class: "dialog-custom__title m-0" }
const _hoisted_3 = {
  key: 0,
  class: "bt-icon bt-icon--xs"
}
const _hoisted_4 = {
  key: 1,
  class: "pi pi-chevron-left mr-1"
}
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = {
  key: 0,
  class: "dialog-custom__content form-custom m-0"
}
const _hoisted_7 = { style: {"width":"450px","height":"calc(100vh - 330px)"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = {
  for: "email",
  class: "fs-13 label-error email-not-valid"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "p-field-label" }
const _hoisted_13 = {
  for: "email",
  class: "fs-13 label-error email-not-valid"
}
const _hoisted_14 = {
  key: 1,
  class: "dialog-custom__content form-custom m-0"
}
const _hoisted_15 = {
  style: {"width":"450px","height":"calc(100vh - 330px)"},
  class: "centered-container"
}
const _hoisted_16 = { class: "p-field-label" }
const _hoisted_17 = { class: "bt-icon bt-icon--xs" }
const _hoisted_18 = { class: "ml-2" }
const _hoisted_19 = { class: "p-field-label" }
const _hoisted_20 = { class: "bt-icon bt-icon--xs" }
const _hoisted_21 = { class: "ml-2" }
const _hoisted_22 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ScrollableTabView = _resolveComponent("ScrollableTabView")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom invite-residents_dialog"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.showImportSection
                        ? _ctx.$t("entrancePlant.importResidentsTitle")
                        : _ctx.$t("AppResourceEP.InviteTheResidents")), 1),
        _createVNode(_component_Button, {
          class: "p-button-text ml-auto",
          onClick: _ctx.handleExportImportProcedure
        }, {
          default: _withCtx(() => [
            (!_ctx.showImportSection)
              ? (_openBlock(), _createBlock("span", _hoisted_3, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: require(`@/assets/images/icons/icon-import.svg`),
                    "aria-label": "icon-import"
                  }, null, 8, ["src"])
                ]))
              : (_openBlock(), _createBlock("i", _hoisted_4)),
            _createVNode("span", _hoisted_5, _toDisplayString(!_ctx.showImportSection ? _ctx.$t("entrancePlant.import") : _ctx.$t("AppResource.Back")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (!_ctx.showImportSection)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_ScrollableTabView, {
                scrollable: "",
                class: "p-tabview--custom white-back"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.buildings, (building, index) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: index,
                      header: _ctx.tabBuildingLabel(building)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElScrollbar, { class: "apartment-list" }, {
                          default: _withCtx(() => [
                            (_ctx.currentEntrancePlant.addressingType === _ctx.AddressingType.BuildingRiserFloorApartment)
                              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.buildingStructure(building), (riser, riserIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: riserIndex,
                                    class: "p-field"
                                  }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.floors, (floorsection, floorIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        key: floorIndex,
                                        class: "p-field"
                                      }, [
                                        _createVNode("h6", null, _toDisplayString(riser.riser.name) + " - " + _toDisplayString(floorsection.floor.name), 1),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorsection.apartments, (apartment, aptIndex) => {
                                          return (_openBlock(), _createBlock("div", {
                                            key: aptIndex,
                                            class: "p-field"
                                          }, [
                                            (apartment.apartmentId)
                                              ? (_openBlock(), _createBlock("span", _hoisted_8, [
                                                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.apartmentInputLabel(apartment)), 1),
                                                  _createVNode(_component_InputText, {
                                                    disabled: _ctx.disableInput(apartment),
                                                    type: "email",
                                                    class: ["w-100", { 'input-error': !_ctx.emailInput[apartment.apartmentId].isValid }],
                                                    placeholder: apartment.canInvite 
                                                        ? _ctx.$t('AppResourceEP.InsertTheEmail') 
                                                        : _ctx.$t('entrancePlant.invitionDisabledApartmentNotSynced'),
                                                    modelValue: _ctx.emailInput[apartment.apartmentId].email,
                                                    "onUpdate:modelValue": ($event: any) => (_ctx.emailInput[apartment.apartmentId].email = $event),
                                                    onFocus: ($event: any) => (_ctx.emailInput[apartment.apartmentId].isValid = true),
                                                    onBlur: ($event: any) => (_ctx.checkMailValid(apartment.apartmentId))
                                                  }, null, 8, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue", "onFocus", "class", "onBlur"]),
                                                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.getErrorLabel(apartment.apartmentId)), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(building.apartments, (apartment, apartmentIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: apartmentIndex,
                                    class: "p-field"
                                  }, [
                                    (apartment.apartmentId)
                                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                          _createVNode("label", _hoisted_12, _toDisplayString(_ctx.apartmentInputLabel(apartment)), 1),
                                          _createVNode(_component_InputText, {
                                            disabled: _ctx.disableInput(apartment),
                                            type: "email",
                                            class: ["w-100", { 'input-error': !_ctx.emailInput[apartment.apartmentId].isValid }],
                                            placeholder: apartment.canInvite 
                                                ? _ctx.$t('AppResourceEP.InsertTheEmail') 
                                                : _ctx.$t('entrancePlant.invitionDisabledApartmentNotSynced'),
                                            modelValue: _ctx.emailInput[apartment.apartmentId].email,
                                            "onUpdate:modelValue": ($event: any) => (_ctx.emailInput[apartment.apartmentId].email = $event),
                                            onFocus: ($event: any) => (_ctx.emailInput[apartment.apartmentId].isValid = true),
                                            onBlur: ($event: any) => (_ctx.checkMailValid(apartment.apartmentId))
                                          }, null, 8, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue", "onFocus", "class", "onBlur"]),
                                          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.getErrorLabel(apartment.apartmentId)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["header"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showImportSection)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, " 1 - " + _toDisplayString(_ctx.$t("entrancePlant.createMassiveInvitationCSV").toUpperCase()), 1),
              _createVNode(_component_Button, {
                class: "p-button-rounded p-button-outlined mx-auto",
                onClick: _ctx.handleExportClick
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_17, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require(`@/assets/images/icons/icon-plus-outline.svg`),
                      "aria-label": "icon-create"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("entrancePlant.createTemplateCSV")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode("label", _hoisted_19, " 2 - " + _toDisplayString(_ctx.$t("entrancePlant.importMassiveInviteInstructions").toUpperCase()), 1),
              _createVNode(_component_Button, {
                onClick: _ctx.triggerFilePicker,
                class: "p-button-rounded p-button-outlined mx-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode("input", {
                    type: "file",
                    id: "fileInput",
                    style: {"display":"none"},
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                    accept: ".csv"
                  }, null, 32),
                  _createVNode("span", _hoisted_20, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: require(`@/assets/images/icons/icon-import.svg`),
                      "aria-label": "icon-import"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("entrancePlant.import")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("footer", _hoisted_22, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          disabled: _ctx.showImportSection,
          label: _ctx.$t('AppResourceEP.InviteUpper'),
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m"
        }, null, 8, ["disabled", "label", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}